module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subheading"
  }, [_vm._v("\n    " + _vm._s(_vm.invoice.title) + "\n    "), _c('v-chip', {
    attrs: {
      "small": ""
    }
  }, [_vm._v(_vm._s(_vm.invoice.status))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('span', {
    staticClass: "pr-4"
  }, [_vm._v("\n      " + _vm._s(_vm.formatCurrency(_vm.invoice.currency, _vm.invoice.invoice_amount)) + "\n    ")])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Invoice date: " + _vm._s(_vm.invoice.date))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n          Due date: " + _vm._s(_vm.invoice.due_date) + "\n        ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("My info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Address, banking details, practice name and number\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Practice: " + _vm._s(_vm.invoice.context.practice_name))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Number: " + _vm._s(_vm.invoice.context.practice_number) + "\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Contact details")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.invoice.invoicee_details || _vm.invoice.context.from_string) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Banking details")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            " + _vm._s(_vm.invoice.context.banking_details) + "\n          ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-list-tile', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Customer billing info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n            Bill to, medical aid info\n          ")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Bill to")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.invoice.context.customer_info))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Medical Aid info")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(_vm.invoice.context.medicalaid_info))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("edit")])], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1) : _vm._e(), _vm._v(" "), (_vm.invoice.context) ? _c('v-list-group', [_c('v-subheader', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("Line items")]), _vm._v(" "), _vm._l((_vm.invoice.context.appointments), function(appointment) {
    return [_c('v-divider', {
      key: ((appointment.id) + "-d")
    }), _vm._v(" "), _c('v-list-tile', {
      key: appointment.id
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(appointment.invoice_title || appointment.full_name) + "\n            ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(_vm.dateformat(appointment.start_time)) + "\n            ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n            " + _vm._s(_vm.formatCurrency(_vm.invoice.currency, appointment.price)) + "\n          ")])], 1), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? [_c('v-subheader', {
      key: ((appointment.id) + "-h"),
      staticClass: "py-0 my-0"
    }, [_vm._v("Codes:")]), _vm._v(" "), _vm._l((appointment.codes), function(code) {
      return _c('div', {
        key: code.id,
        staticClass: "mr-3 text-xs-right"
      }, [_c('span', {
        staticClass: "mx-2"
      }, [_vm._v(_vm._s(code.icd10))]), _vm._v(" "), _c('span', {
        staticClass: "mx-2"
      }, [_vm._v(_vm._s(code.process))]), _vm._v(" "), _c('span', {
        staticClass: "ml-2"
      }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.invoice.currency, code.price)))])])
    })] : _vm._e()]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("view", _vm.invoice)
      }
    }
  }, [_vm._v("View "), _c('v-icon', {
    staticClass: "pl-1"
  }, [_vm._v("open_in_new")])], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("send", _vm.invoice)
      }
    }
  }, [_vm._v("Send "), _c('v-icon', {
    staticClass: "pl-1"
  }, [_vm._v("send")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("edit", _vm.invoice)
      }
    }
  }, [_vm._v("More "), _c('v-icon', [_vm._v("chevron_right")])], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "pl-2"
  }, [_vm._v("\n    #" + _vm._s(_vm.invoice.id) + "\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49edbe77","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoice/Preview.vue
// module id = 1415
// module chunks = 9